// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"73559e05","453":"d250f02d","671":"f0118cf2"}[chunkId] + ".chunk.js";
};